
import React, { useEffect } from 'react';

const EventQuestionSettings = (props) => {

  const deleteSvgPath = "M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z";

  const editSvgPath = "M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z";

  return (
    <div className="event-question-settings">
      {props.IsSubquestion === 0 ?
        <>
          <div className="event-question-settings-optn" style={{ cursor: "pointer" }} onClick={(e)=>{ props.setOpenSettingsId(""); props.setParentSubQuestionFlag(true) }}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960"
                    width="24" style={{ cursor: "pointer"}} >
                <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
            </svg> Add Parent Question
          </div>
        </>
      :
        <>
          <div className="event-question-settings-optn" style={{ cursor: "pointer" }} onClick={(e)=>{props.setOpenSettingsId(""); props.setParentSubQuestionFlag(true); props.setParentQuestionEdit('edit_details'); }}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={editSvgPath} style={{ cursor: "pointer"}} /></svg> Edit Parent Question
          </div>
          <hr />
          <div className="event-question-settings-optn" style={{ cursor: "pointer" }} onClick={() => { props.setOpenSettingsId(""); props.setDeleteSubQuestion(true); }}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960"
                      width="24" style={{ cursor: "pointer"}} >
                  <path d={deleteSvgPath} />
            </svg> Delete Parent Question
          </div>
        </>
      }
      
    </div>
  );
};

export default EventQuestionSettings;